(function() {
  // Find the section element via the wrapping Shopify section div
  var sectionWrapper = document.currentScript.closest('[id^="shopify-section"]');
  var section = sectionWrapper ? sectionWrapper.querySelector('.ccnav') : document.querySelector('.ccnav');

  if (!section) return;

  var collectionTitle = section.dataset.collectionTitle;
  var collectionHandle = section.dataset.collectionHandle;
  var sectionId = section.id.replace('ccnav-', '');
  var isGeneric = (collectionHandle === 'all' || collectionHandle === 'bestsellers');
  var productMap = {};
  var variantMap = {};

  try {
    var mapEl = document.getElementById('collection-product-map-' + sectionId);
    if (mapEl) productMap = JSON.parse(mapEl.textContent);
  } catch(e) {}
  try {
    var varEl = document.getElementById('collection-variant-map-' + sectionId);
    if (varEl) variantMap = JSON.parse(varEl.textContent);
  } catch(e) {}

  function getHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    return m ? m[1] : null;
  }

  function enhanceCard(card) {
    var infoArea = card.querySelector('.group-block-content');
    if (!infoArea) return;

    if (!card.querySelector('.pc-type-label')) {
      var labelText = isGeneric ? (productMap[getHandle(card)] || '') : collectionTitle;
      if (labelText) {
        var imageWrapper = card.querySelector('.card-media') || card.querySelector('.image-wrapper') || card.querySelector('a[ref="productCardLink"]');
        var label = document.createElement('span');
        label.className = 'pc-type-label';
        label.textContent = labelText;
        if (imageWrapper && imageWrapper.parentElement) {
          imageWrapper.parentElement.style.position = 'relative';
          imageWrapper.parentElement.appendChild(label);
        } else {
          card.style.position = 'relative';
          card.insertBefore(label, card.firstChild);
        }
      }
    }

    // For multi-variant products: show "fr." + min price
    var priceEl = infoArea.querySelector('product-price');
    if (priceEl && !priceEl.dataset.priceFixed) {
      var handle = getHandle(card);
      if (handle && variantMap[handle] && variantMap[handle].count > 1) {
        var minCents = variantMap[handle].min_price;
        var formatted = (minCents / 100).toFixed(2).replace('.', ',');
        var priceText = priceEl.querySelector('.price, [class*="price"]');
        if (!priceText) {
          var allEls = priceEl.querySelectorAll('*');
          for (var i = 0; i < allEls.length; i++) {
            if (allEls[i].textContent.includes('\u20ac')) { priceText = allEls[i]; break; }
          }
        }
        if (priceText) {
          priceText.textContent = 'fr. \u20ac' + formatted + ' EUR';
        }
        priceEl.dataset.priceFixed = 'true';
      }
    }
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'PRODUCT-CARD') enhanceCard(node);
        var cards = node.querySelectorAll ? node.querySelectorAll('product-card') : [];
        cards.forEach(enhanceCard);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.querySelectorAll('product-card').forEach(enhanceCard);
})();
